// extracted by mini-css-extract-plugin
export default {"wrapper":"OpenPositions_wrapper__-iz-9","jobs_list":"OpenPositions_jobs_list__iTchC","job":"OpenPositions_job__CC5Z-"};